import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import ListResponsive from "../../components/other/ListResponsive";
import { postNotification } from "../../components/utilities/Notifications";
import moment from "moment";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { BCPSquarePlus } from "../../components/icons/bcp/BCPIcons";
import { signout } from "../../components/user/BCPAuth";
import {
  useProcessing,
  useSignout
} from "../../components/user/BCPAuthReducers";
import { useNavigate } from "react-router";
import { getData } from "../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { stringToUrl } from "../events/utils/event";
import { useTranslation } from "react-i18next";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";
const SINGLE_GAME_MANUFACTURER = getEnvironmentVariable(
  "SINGLE_GAME_MANUFACTURER"
);
const SINGLE_GAME_SYSTEM = getEnvironmentVariable("SINGLE_GAME_SYSTEM");

export default function EventsCasual() {
  const authContext = useContext(AuthContext);
  const { t } = useTranslation("translation", {
    keyPrefix: "pages.play.CasualPlay"
  });

  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const screenWidth = window.innerWidth;
  const getGameResultDetails = (gameResult) => {
    let result = "";
    if (gameResult >= 2) {
      result = "Win";
      // eslint-disable-next-line
    } else if (gameResult == 1) {
      result = "Draw";
      // eslint-disable-next-line
    } else if (gameResult == 0) {
      result = "Loss";
    }
    var color = `${result.toLowerCase()}.main`;
    result = t(result.toLowerCase(), { keyPrefix: "misc.pairings" });

    return {
      result,
      color
    };
  };

  const navigate = useNavigate();
  const useSignoutReducer = useSignout();
  const useProcessingReducer = useProcessing();

  useEffect(() => {
    const go = async () => {
      try {
        let apiGames = [];

        let query = {
          pairingType: "CasualPairing",
          sortAscending: false,
          userPairings: true,
          "expand[]": ["gameSystem"]
        };

        if (SINGLE_GAME_MANUFACTURER) {
          query.manufacturer = SINGLE_GAME_MANUFACTURER;
        }
        if (SINGLE_GAME_SYSTEM) {
          query.gameSystemId = SINGLE_GAME_SYSTEM;
        }

        if (
          NO_SUBSCRIPTIONS ||
          authContext?.authState?.identity?.subscriber ||
          authContext?.authState?.identity?.isAdmin
        ) {
          apiGames = await handlePagingAll("/pairings", query);
        } else {
          query.limit = 10;
          apiGames = await getData("/pairings", {
            queryStringParameters: query
          });
          apiGames = apiGames?.data || [];
        }

        setGames(apiGames);
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          try {
            if (IS_BCP) {
              navigate("/logout");
            } else {
              await signout(useSignoutReducer, {
                setProcessing: useProcessingReducer,
                navigate: navigate
              });
            }
          } catch (err) {
            postNotification("error", err);
          }
          navigate(`/login?redirect_url=${stringToUrl(window.location.href)}`);
          return;
        } else {
          postNotification("error", err);
        }
      } finally {
        setLoading(false);
      }
    };
    go();
    // eslint-disable-next-line
  }, []);

  const ListRow = (props) => {
    const { heading, row } = props;

    const player1Results =
      row?.player1Game?.gameResult !== undefined
        ? getGameResultDetails(row?.player1Game?.gameResult)
        : undefined;
    const player2Results =
      row?.player2Game?.gameResult !== undefined
        ? getGameResultDetails(row?.player2Game?.gameResult)
        : undefined;

    return (
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{
          p: 1,
          fontSize: "14px",
          overflow: "hidden",
          textAlign: "center",
          borderBottom: heading ? "" : "1px solid",
          borderImage: heading
            ? ""
            : screenWidth > 600
              ? "linear-gradient(to right, rgba(0,0,0,0) 1%, black 1%, black 99%, rgba(0,0,0,0) 99%) 1;"
              : "linear-gradient(to right, rgba(0,0,0,0) 3%, black 3%, black 99%, rgba(0,0,0,0) 99%) 1;"
        }}
      >
        <Grid item xs sx={{ maxWidth: ["70px", "100px"] }}>
          {heading ? t("date") : moment(row.created_at).format("LL")}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["125px", "unset"], overflow: "hidden" }}>
          {heading ? t("game") : row.gameSystem?.name}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["125px", "unset"], overflow: "hidden" }}>
          {heading ? (
            t("title")
          ) : (
            <Link href={`/game/casualpairing/${row?.id}`} underline="none">
              {row.pairingName}
            </Link>
          )}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["70px", "130px"], overflow: "hidden" }}>
          {heading ? (
            `${t("player")} 1`
          ) : (
            <>
              <Typography variant="body2">
                {row?.player1?.firstName || row?.player1?.user?.firstName}
              </Typography>
              {player1Results ? (
                <Typography variant="body2" color={player1Results?.color}>
                  {player1Results?.result}
                  {row.player1Game?.gamePoints
                    ? ` : ${row.player1Game.gamePoints}`
                    : ""}
                </Typography>
              ) : (
                <Typography variant="body2">---</Typography>
              )}
            </>
          )}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["70px", "130px"], overflow: "hidden" }}>
          {heading ? (
            `${t("player")} 2`
          ) : (
            <>
              <Typography variant="body2">
                {row?.player2?.firstName || row?.player2?.user?.firstName}
              </Typography>
              {player2Results ? (
                <Typography variant="body2" color={player2Results?.color}>
                  {player2Results?.result}
                  {row.player2Game?.gamePoints
                    ? ` : ${row.player2Game.gamePoints}`
                    : ""}
                </Typography>
              ) : (
                <Typography variant="body2">---</Typography>
              )}
            </>
          )}
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
          <Grid container sx={{ gap: 2 }}>
            <Grid
              item
              xs={12}
              sx={{ p: 2, borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
            >
              <Typography
                variant="h2"
                component="h3"
                fontWeight="700"
                gutterBottom
              >
                {t("myGames")}
              </Typography>
              <Typography variant="caption">
                {t("myGamesDescription")}
              </Typography>
            </Grid>

            <Grid item xs={12} sx={{ p: 2 }}>
              <ListResponsive
                originalList={loading ? null : games}
                doSearch
                doPages
                initialRowsPerPage={10}
                rowsPerPageArray={[10, 25, 50, { label: "All", value: -1 }]}
                actionButton={{
                  props: {
                    variant: "contained",
                    color: "primary",
                    fullWidth: true,
                    href: "/play/new-game",
                    startIcon: <BCPSquarePlus />
                  },
                  label: t("newGame", {
                    keyPrefix: "buttons"
                  })
                }}
                searchProps={{
                  label: t("searchGames", {
                    keyPrefix: "buttons"
                  }),
                  performSearch: (originalList, searchText) => {
                    if (!searchText || searchText === "") {
                      return originalList;
                    } else {
                      var filteredList = originalList.filter(function (el) {
                        if (el?.pairingName?.toLowerCase().includes(searchText))
                          return true;
                        if (
                          el?.gameSystem?.name
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          moment(el?.created_at)
                            .format("LL")
                            .toLowerCase()
                            .includes(searchText)
                        )
                          return true;

                        if (
                          el?.player1?.firstName
                            ?.toLowerCase()
                            .includes(searchText) ||
                          el?.player1?.user?.firstName
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          el?.player2?.firstName
                            ?.toLowerCase()
                            .includes(searchText) ||
                          el?.player2?.user?.firstName
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        return false;
                      });
                      return filteredList;
                    }
                  }
                }}
                rowProps={{
                  headings: (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        p: "2px",
                        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: "4px 4px 0 0",
                        backgroundColor: "table.headerBackground",
                        color: "table.headerColor"
                      }}
                    >
                      <ListRow heading />
                    </Grid>
                  ),

                  mapFunction: (row, index) => <ListRow row={row} key={index} />
                }}
              />
            </Grid>

            {!NO_SUBSCRIPTIONS &&
              !authContext?.authState?.identity?.subscriber &&
              !authContext?.authState?.identity?.isAdmin && (
                <Grid item xs={12} sx={{ pl: 2, pr: 2 }}>
                  <Typography gutterBottom textAlign="center">
                    {t("noSubScription")}{" "}
                    <Link href="/subscription" target="_blank">
                      {t("subscriber")}
                    </Link>
                  </Typography>
                </Grid>
              )}
          </Grid>
        </Container>
      </Box>
    </>
  );
}
